/**
 * flagEnumContainsValue was added to minimize boilerplate code when working with flag enums.
 *
 * checks if a bitmask contains bit value.
 *
 * @param bitMask number, the bitmask numerical value
 * @param bit number, the bit numberical value that must be contained within the bitmask
 * @example
 * bitMaskContains(Enum.Value1, Enum.Value2 | Enum.Value3)
 * Enum.Value1 = (1 << 2 | 1 << 3)
 * Enum.Value2 = 1 << 2
 * Enum.Value3 = 1 << 3
 * (0110 & (0010 | 0100)) = 0110
 * 0110 is equal to 6 === 4 | 2
 * return true
 * @example
 * bitMaskContains(Enum.Value1, Enum.Value2 | Enum.Value3)
 * Enum.Value1 = 1 << 4
 * Enum.Value2 = 1 << 2
 * Enum.Value3 = 1 << 3
 * 1000 & (0010 | 0100) = 0000
 * 0000 = 0 is equal to 0 which is not equal to 6
 * return false
 */
export function flagEnumContainsValue(bitMask: number, bit: number): boolean {
    return (bitMask & bit) === bit;
}
